/** Typed DOM lookup helpers used by the UI layer. */
export function el<T extends HTMLElement = HTMLElement>(id: string): T {
  const node = document.getElementById(id);
  if (!node) throw new Error(`Missing element #${id}`);
  return node as T;
}

export function show(node: HTMLElement): void {
  node.classList.remove('hidden');
  node.setAttribute('aria-hidden', 'false');
}

export function hide(node: HTMLElement): void {
  node.classList.add('hidden');
  node.setAttribute('aria-hidden', 'true');
}
